import {
  HEADER_FIRST_LINE,
  HEADER_SECOND_LINE,
  BODY_FIRST_LINE,
  BODY_SECOND_LINE,
  BODY_SECOND_LINE_STATUS,
  SELECT_FOOTER,
  LABEL_FOOTER,
  REQUEST_FIRST_LINE,
  REQUEST_SECOND_LINE,
} from '@/components/Majority/constants/tableStyles';

import {
  BTN_ACTION,
  BTN_EXPORT,
  BTN_UPLOAD,
} from '@/components/Majority/constants/actionStyles';

import GenericFunctionsMixin from '@/shared/mixins/genericFunctions/genericFunctionsMixin';
import { BTN_FILTER, COL_FILTER } from '@/components/Majority/constants/filterStyles';
import MajorityRules from '@/components/Majority/rules/majorityRules';
import moment from 'moment';

export default {
  name: "MajorityMixin",

  data: () => ({
    moment,
  }),

  mixins: [
    GenericFunctionsMixin,
    MajorityRules,
  ],

  methods: {
    hasMajorityQueryParameters() {
      const keys = ['competency', 'financialGroupId', 'contractId', 'subContractId', 'externalProtocol'];

      const majorityQueryFilter = keys.reduce((acc, key) => {
        const value = this.$route.query[key];
        if (value !== undefined && value !== null && value !== '') {
          acc[key] = value;
        }
        return acc;
      }, {});

      return Object.keys(majorityQueryFilter).length > 0;
    },
    majorityViewReference() {
      return this.fetchAncestorByReferenceName(this, 'MajorityView') || false;
    },

    getTooltipMessage(beneficiary) {
      if (!(beneficiary.majorityStatus === 'PENDING' && beneficiary.externalProtocolStatus === 'closed')) {
        return 'O atendimento ainda esta aberto.';
      }

      if (!['EXTENDED', 'EXCLUDED', 'CANCELED'].includes(beneficiary.majorityStatus)) return false;

      if (beneficiary.majorityStatus === 'EXTENDED') {
        return 'Este dependente já possui uma permanência confirmada.';
      }

      if (beneficiary.majorityStatus === 'EXCLUDED') {
        return 'Este dependente já possui uma data fim de vigência programada.';
      }

      if (beneficiary.majorityStatus === 'CANCELED') {
        return 'Esse registro de maioridade foi reprocessado.';
      }
    },


  },

  computed: {
    invalidReprocessMessage() {
      if (!this.hasMajorities) return 'Nenhum registro de maioridade encontrado.';

      if (!this.isReprocessable) {
        return 'Esses registros de maioridade não podem ser reprocessados.';
      }

      return 'Selecione ao menos o filtro Grupo Financeiro e Contrato para poder reprocessar.';
    },

    headerFirstLine() {
      return HEADER_FIRST_LINE;
    },

    headerSecondLine() {
      return HEADER_SECOND_LINE;
    },

    requestFirstLine() {
      return REQUEST_FIRST_LINE;
    },

    requestSecondLine() {
      return REQUEST_SECOND_LINE;
    },

    colFilter() {
      return COL_FILTER;
    },

    btnFilter() {
      return BTN_FILTER;
    },

    bodyFirstLine() {
      return BODY_FIRST_LINE;
    },

    bodySecondLine() {
      return BODY_SECOND_LINE;
    },

    bodySecondLineStatus() {
      return BODY_SECOND_LINE_STATUS;
    },

    selectFooter() {
      return SELECT_FOOTER;
    },

    labelFooter() {
      return LABEL_FOOTER;
    },

    btnAction() {
      return BTN_ACTION;
    },

    btnUpload() {
      return BTN_UPLOAD;
    },

    btnExport() {
      return BTN_EXPORT;
    },
  }
}